import { format, isValid, parse } from 'date-fns';

/** The shape a date takes in a URL query param and in the report endpoints' query strings. */
export const DATE_PARAM_FORMAT = 'yyyy-MM-dd';

/** Drops the time so only the calendar day travels, whatever the browser's timezone. */
export function formatDateParam(date: Date): string {
  return format(date, DATE_PARAM_FORMAT);
}

/** Parsed as a local calendar date, so a picker shows the day that was in the URL. */
export function parseDateParam(value: string | null): Date | null {
  if (!value) return null;

  const parsed = parse(value, DATE_PARAM_FORMAT, new Date());

  return isValid(parsed) ? parsed : null;
}

/** Reads a positive integer param, falling back when it is missing or malformed. */
export function parseNumberParam(value: string | null, fallback: number): number {
  const parsed = Number(value);

  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
}
